import { render } from "./Achievements.vue?vue&type=template&id=9aac927c&scoped=true&ts=true"
import script from "./Achievements.vue?vue&type=script&lang=ts"
export * from "./Achievements.vue?vue&type=script&lang=ts"

import "./Achievements.vue?vue&type=style&index=0&id=9aac927c&lang=scss&scoped=true"
import "./Achievements.vue?vue&type=style&index=1&id=9aac927c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aac927c"]])

export default __exports__